'use client';

/* empty css                                     */
/* empty css                                        */
import "./src/themes/color.css.ts.vanilla.css.js";
/* empty css                                     */
/* empty css                                      */
/* empty css                                      */
/* empty css                                       */
/* empty css                                        */
/* empty css                                         */
import "./src/atomic/sprinkles.ts.vanilla.css.js";
/* empty css                                          */
var visuallyHidden = "c5-10-0_1lxmpax1 c5-10-0_1lxmpax0 c5-10-0_nly6ul33 c5-10-0_nly6ul35 c5-10-0_161xunp8 c5-10-0_161xunp24 c5-10-0_161xunp40 c5-10-0_161xunp5w c5-10-0_161xunp7s c5-10-0_161xunp9o c5-10-0_161xunpbk c5-10-0_161xunpdg c5-10-0_nly6ulo c5-10-0_zqwrxxr";
var fillParent = "c5-10-0_1lxmpax5 c5-10-0_1lxmpax4 c5-10-0_nly6ulo c5-10-0_1lxmpax3 c5-10-0_1lxmpax2 c5-10-0_nly6ul3b c5-10-0_nly6ul3e c5-10-0_nly6ul3c c5-10-0_nly6ul3d";
var fillParentAfter = "c5-10-0_1lxmpax6";
var fillScreen = "c5-10-0_1lxmpax8 c5-10-0_1lxmpax7 c5-10-0_nly6uls c5-10-0_1lxmpax3 c5-10-0_1lxmpax2 c5-10-0_nly6ul3b c5-10-0_nly6ul3e c5-10-0_nly6ul3c c5-10-0_nly6ul3d";
var absoluteCentered = "c5-10-0_1lxmpaxa c5-10-0_1lxmpax9 c5-10-0_nly6ulo c5-10-0_nly6ul4";
var chalkFocusRules = { high: { boxShadow: "white 0px 0px 0px 4px, #2A4ECC 0px 0px 0px 6px, #2A4ECC 0px 0px 1px 6px" }, medium: { boxShadow: "#2A4ECC 0px 0px 0px 2px, white 0px 0px 0px 3px" }, low: { boxShadow: "#2A4ECC 0px 0px 0px 2px" } };
var chalkFocus = { high: "c5-10-0_1lxmpaxb", medium: "c5-10-0_1lxmpaxc", low: "c5-10-0_1lxmpaxd" };
var chalkFocusWithin = { high: "c5-10-0_1lxmpaxe", medium: "c5-10-0_1lxmpaxf", low: "c5-10-0_1lxmpaxg" };
var chalkFocusWithActiveOutline = { high: "c5-10-0_1lxmpaxh", medium: "c5-10-0_1lxmpaxi", low: "c5-10-0_1lxmpaxj" };
export {
  absoluteCentered,
  chalkFocus,
  chalkFocusRules,
  chalkFocusWithActiveOutline,
  chalkFocusWithin,
  fillParent,
  fillParentAfter,
  fillScreen,
  visuallyHidden
};
